var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoProtection = function SvgInfoProtection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2FBC44",
    fillRule: "evenodd",
    d: "M17.351 3.394q.272 0 .554-.009a.65.65 0 0 1 .667.648v7.88c0 2.237-.864 5.501-8.339 7.998a.73.73 0 0 1-.465 0c-7.475-2.497-8.339-5.76-8.339-7.998v-7.88c0-.365.302-.658.667-.648C7.13 3.534 9.363.648 9.516.45l.009-.01a.693.693 0 0 1 .952 0l.008.01c.143.187 2.256 2.944 6.866 2.944M10.087 15.16a5.086 5.086 0 0 0 5.085-5.086h-5.086V4.99a5.086 5.086 0 0 0 0 10.172m4.2-6.613v.002h-2.858V5.692a2.857 2.857 0 0 1 2.857 2.856",
    clipRule: "evenodd"
  })));
};
export default SvgInfoProtection;